const CALL_WINDOW_BRIDGE_KEY = "__meBusinessCallBridge";

const makeCallToken = () => {
    if (window.crypto?.randomUUID) {
        return window.crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getOrCreateCallWindowBridge = (targetWindow = window) => {
    if (targetWindow[CALL_WINDOW_BRIDGE_KEY]) {
        return targetWindow[CALL_WINDOW_BRIDGE_KEY];
    }

    const pendingCalls = new Map();
    const listeners = new Set();
    const bridge = {
        matrixClient: null,
        headers: null,
        currentUser: null,
        pendingCalls,
        callNotes: [],
        addCallNote: null,
        reportStatus: null,
        registerCall(descriptor) {
            const callToken = makeCallToken();
            pendingCalls.set(callToken, descriptor);
            return callToken;
        },
        getCall(callToken) {
            return pendingCalls.get(callToken) || null;
        },
        removeCall(callToken) {
            pendingCalls.delete(callToken);
        },
        update(nextValues) {
            Object.assign(bridge, nextValues);
            listeners.forEach(listener => listener());
        },
        subscribe(listener) {
            listeners.add(listener);
            return () => listeners.delete(listener);
        }
    };

    targetWindow[CALL_WINDOW_BRIDGE_KEY] = bridge;
    return bridge;
};

export const getOpenerCallWindowBridge = () => {
    try {
        return window.opener?.[CALL_WINDOW_BRIDGE_KEY] || null;
    } catch {
        return null;
    }
};

